module.exports = __webpack_public_path__ + "img/desktop-logo.268ca49b.svg";